/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div data-testid="not-found-page" className="min-h-[70vh] flex items-center">
            <div className="max-w-2xl mx-auto px-6 text-center">
                <p className="font-serif text-8xl font-bold text-[#D4AF37]">404</p>
                <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#0A192F] mt-4">
                    This page took a different path.
                </h1>
                <p className="mt-4 text-slate-600">
                    The page you're looking for can't be found. Let's get you
                    back to building.
                </p>
                <Link
                    to="/"
                    data-testid="not-found-home-link"
                    className="mt-10 inline-flex items-center gap-2 bg-[#0A192F] text-white hover:bg-[#1E3A8A] rounded-sm px-7 py-3 font-bold text-sm uppercase tracking-widest"
                >
                    <ArrowLeft className="w-4 h-4" /> Return Home
                </Link>
            </div>
        </div>
    );
}
